import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Nivel } from '../../_models/nivel';
import { NivelesService } from '../../_services/niveles.service';
import { NivelRango } from '../../_models/nivel-rango';
import { NivelRangoService } from '../../_services/nivel-rango.service';
import { UsuariosService } from '../../_services/usuarios.service';

@Component( {
  templateUrl: 'niveles-formulario.component.html',
  selector: 'app-niveles'
} )
export class NivelesAgregarComponent implements OnInit {
  formulario: FormGroup;
  niveles: Nivel[];
  nivel: Nivel;
  guardando: boolean;
  codExiste: boolean;
  submitted: boolean;
  editando: boolean;
  submittedRangos: boolean;
  formularioR: FormGroup;
  nivelRango: NivelRango;
  guardandoR: boolean;
  columnasR: any[];
  nivelesRangos: NivelRango[];
  carNivelesR: boolean;
  mostrarSeccion: boolean;
  idNivel: string;
  puedeManejarTasa = false;
  manejaDctoTasa = false;

  constructor( private navServicio: NavService,
               private router: Router,
               private route: ActivatedRoute,
               private formBuilder: FormBuilder,
               private nivelesServicio: NivelesService,
               private nivelRangoService: NivelRangoService,
               private usuariosService: UsuariosService,
               private confirmacionServicio: ConfirmationService ) {
    this.editando = false;
  }

  ngOnInit(): void {
    this.formulario = this.formBuilder.group( {
      idNivel: [ null ],
      idSegmento: [ null ],
      codigo: [ '', [ Validators.required, Validators.maxLength( 6 ) ] ],
      nombre: [ '', Validators.required ],
      descripcion: [ '' ],
      indicadorManejaTasa: [ false ],
      indicadorManejaDctoTasa: [ false ],
      indicadorAprueba: [ false ],
      indicadorHabilitado: [ true ],
    } );
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.nivelesServicio.obtener( params[ 'id' ] ).subscribe( res => {
          this.nivel = res;
          this.puedeManejarTasa = !!this.nivel.indicadorManejaTasa;
          this.manejaDctoTasa = !!this.nivel.indicadorManejaDctoTasa;
          this.mostrarSeccion = res.indicadorAprueba;
          this.editando = true;
          this.codExiste = false;
          this.idNivel = res.idNivel;
          this.formulario = this.formBuilder.group( {
            idNivel: [ this.nivel.idNivel ],
            codigo: [ this.nivel.codigo, [ Validators.required, Validators.maxLength( 6 ) ] ],
            nombre: [ this.nivel.nombre, Validators.required ],
            indicadorManejaTasa: [ this.nivel.indicadorManejaTasa ],
            indicadorAprueba: [ this.nivel.indicadorAprueba ],
            indicadorManejaDctoTasa: [ this.nivel.indicadorManejaDctoTasa ],
            indicadorHabilitado: [ this.nivel.indicadorHabilitado ],
            auditoriaUsuario: [ this.nivel.auditoriaUsuario ],
            auditoriaFecha: [ this.nivel.auditoriaFecha ],
          } );
          this.construirFormularioRangos( res.idNivel );
        }, res => res );
        this.cargarTablaNivelesCargos( params[ 'id' ] );
      } else {
        this.nivelesServicio.listado().subscribe( res => {
          this.niveles = res;
        }, e => {
          this.niveles = [];
        } );
        this.construirFormularioRangos( this.idNivel );
      }

    } );
    this.columnasR = [
      { field: 'nombreRango', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_NOMBRERANGO' ), sort: true },
      { field: 'rangoMaximo', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_RANGOMAXIMOT' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_ACCIONES' ), sort: true },
    ];

  }

  cargarTablaNivelesCargos( idNivel: any ) {
    let idnivel = null;
    if ( idNivel ) {
      idnivel = idNivel;
    }
    this.carNivelesR = true;
    this.nivelesRangos = [];
    this.nivelRangoService.listadoNivelRangoByNivel( idnivel ).subscribe( res => {
      this.nivelesRangos = res;
      this.carNivelesR = false;
    }, e => {
      this.nivelesRangos = [];
      this.carNivelesR = false;
    } );
  }

  construirFormularioRangos( idNivel: string ) {
    this.formularioR = this.formBuilder.group( {
      idNivel: idNivel,
      nombre: [ '', [ Validators.required, Validators.maxLength( 100 ) ] ],
      rangoMaximo: [ null, Validators.required ],
      indicadorHabilitado: [ true ],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  get fr() {
    return this.formularioR.controls;
  }

  validarCodigo() {
    if ( this.f.codigo.value !== '' && this.f.codigo.value !== null && this.f.codigo.value !== undefined ) {
      this.codExiste = this.niveles.filter(
        t => (t.codigo === this.f.codigo.value) ).length > 0;
    } else {
      this.codExiste = false;
    }
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && !this.codExiste ) {
      if ( !this.f.idNivel.value ) {
        this.nivel = this.formulario.value;
        this.guardando = true;
        this.nivelesServicio.agregar( this.nivel ).subscribe( res => {
          this.guardando = false;
          this.construirFormularioTasas( this.nivel.indicadorManejaTasa);
          this.construirFormularioDctoTasas( this.nivel.indicadorManejaDctoTasa);
          if ( res.indicadorAprueba ) {
            this.router.navigate( [ 'apl/niveles/actualizar/' + res.idNivel ] );
          } else {
            this.router.navigate( [ 'apl/niveles' ] );
          }
          this.navServicio.setMesage( 1 );
          this.idNivel = res.idNivel;
          this.construirFormularioRangos( res.idNivel );
        }, e => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      } else {
        this.nivel = this.formulario.value;
        this.guardando = true;
        if ( !this.nivel.indicadorAprueba || !this.nivel.indicadorHabilitado ) {
          this.nivelesServicio.validaInhabilitar( this.nivel.idNivel ).subscribe( data => {
            if ( data ) {
              this.actualizar( this.nivel );
            } else {
              if ( !this.nivel.indicadorHabilitado ) {
                this.navServicio.setMesage( 0, {
                  severity: 'error',
                  summary: 'Error',
                  detail: 'No es posible inhabilitar el nivel debido a que hay usuario relacionados a algún rango.'
                } );
              } else if ( !this.nivel.indicadorAprueba ) {
                this.navServicio.setMesage( 0, {
                  severity: 'error',
                  summary: 'Error',
                  detail: 'No es posible actualizar el indicador aprueba del nivel debido a que hay usuario relacionados a algún rango.'
                } );
              }
              this.guardando = false;
            }
          } )
        } else {
          this.actualizar( this.nivel );
        }
      }
    } else {
      return;
    }
  }

  actualizar( nivel: Nivel ) {
    this.nivelesServicio.actualizar( nivel ).subscribe( res => {
      this.guardando = false;
      this.construirFormularioTasas( nivel.indicadorManejaTasa);
      this.construirFormularioDctoTasas( nivel.indicadorManejaDctoTasa);
      if ( !res.indicadorAprueba ) {
        this.router.navigate( [ 'apl/niveles' ] );
      }
      this.mostrarSeccion = this.nivel.indicadorAprueba;
      this.navServicio.setMesage( 2 );
    }, e => {
      this.guardando = false;
      this.navServicio.setMesage( 3 );
    } );
  }

  goBack() {
    if ( this.formulario.dirty ) {
      this.confirmacionServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_SALIRSINGUARDAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate( [ 'apl/niveles' ] );
        }
      } );
    } else {
      this.router.navigate( [ 'apl/niveles' ] );
    }
  }

  onSubmitRango() {
    this.submittedRangos = true;
    if ( this.formularioR.valid ) {
      this.nivelRango = this.formularioR.value;
      this.guardandoR = true;
      if ( this.nivelRango.idNivelRango ) {
        const lista = this.nivelesRangos.filter( x => x.rangoMaximo === this.nivelRango.rangoMaximo );
        if ( lista.find( x => x.idNivelRango !== this.nivelRango.idNivelRango ) ) {
          this.navServicio.setMesage( 0,
            { severity: 'error', summary: 'Error', detail: 'No es posible guardar dos rangos con el mismo valor' } );
          this.guardandoR = false;
        } else {
          if ( !this.nivelRango.indicadorHabilitado ) {
            this.usuariosService.listaUsuariosByNivelRango( this.nivelRango.idNivelRango ).subscribe( rest => {
              if ( rest.length <= 0 ) {
                this.actualizarNivelRango( this.nivelRango );
              } else {
                this.navServicio.setMesage( 0, {
                  severity: 'error',
                  summary: 'Error',
                  detail: 'No es posible inhabilitar el rango debido a que hay usuario relacionados.'
                } );
                this.guardandoR = false;
              }
            } );
          } else {
            this.actualizarNivelRango( this.nivelRango );
          }
        }
      } else {
        if ( this.nivelesRangos.filter( x => x.rangoMaximo === Number( this.nivelRango.rangoMaximo ) ).length > 0 ) {
          this.navServicio.setMesage( 0,
            { severity: 'error', summary: 'Error', detail: 'No es posible guardar dos rangos con el mismo valor' } );
          this.guardandoR = false;
        } else {
          this.nivelRangoService.agregar( this.nivelRango ).subscribe( rest => {
            this.guardandoR = false;
            this.navServicio.setMesage( 1 );
            this.cargarTablaNivelesCargos( rest.idNivel );
            this.construirFormularioRangos( rest.idNivel );
            this.submittedRangos = false;
          }, e => {
            this.guardandoR = false;
            this.navServicio.setMesage( 3 );
          } );

        }
      }
    } else {
      return;
    }
  }

  actualizarNivelRango( nivelRango ) {
    this.nivelRangoService.actualizar( nivelRango ).subscribe( rest => {
      this.guardandoR = false;
      this.navServicio.setMesage( 2 );
      this.cargarTablaNivelesCargos( this.idNivel );
      this.construirFormularioRangos( this.idNivel );
      this.submittedRangos = false;
    }, e => {
      this.guardandoR = false;
      this.navServicio.setMesage( 3 );
    } );
  }

  updateRango( nivelRango: NivelRango ) {
    this.nivelRango = nivelRango;
    this.guardandoR = false;
    this.formularioR = this.formBuilder.group( {
      idNivelRango: nivelRango.idNivelRango,
      idNivel: nivelRango.idNivel,
      nombre: [ nivelRango.nombre, [ Validators.required, Validators.maxLength( 100 ) ] ],
      rangoMaximo: [ nivelRango.rangoMaximo, Validators.required ],
      indicadorHabilitado: [ nivelRango.indicadorHabilitado ],
      auditoriaUsuario: [ nivelRango.auditoriaUsuario ],
      auditoriaFecha: [ nivelRango.auditoriaFecha ],
    } );
  }

  goBackR() {
    if ( this.formularioR.dirty ) {
      this.confirmacionServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_SALIRSINGUARDAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          /*this.nivelRango = null;
          this.construirFormularioRangos( this.idNivel );*/
          this.router.navigate( [ 'apl/niveles' ] );
        }
      } );
    } else {
      /*this.submittedRangos = false;*/
      this.router.navigate( [ 'apl/niveles' ] );
    }
  }

  cambioHabilitado( evento: boolean ) {
    if ( !evento && this.nivel && this.nivel.indicadorTieneRango ) {
      this.f.indicadorHabilitado.setValue( true );
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'NIVELES.MSG_ESTAASOCIADO' )
      } );
    }
  }

  private construirFormularioTasas( indicadorManejaTasa: boolean ) {
    this.puedeManejarTasa = indicadorManejaTasa;
  }
  private construirFormularioDctoTasas( indicadorManejaDctoTasa: boolean ) {
    this.manejaDctoTasa = indicadorManejaDctoTasa;
  }
}
